import DisplayField from '@shared/components/displays/display-field/display-field.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { BPCDisplayConfigField } from '@core/interfaces/bpc-display-config';
import { isArray, isObject, get } from 'lodash';

@Component({
  name: 'bpc-generic-details',
  components: {
    'bpc-display-field': DisplayField,
  },
})
export default class GenericDetails extends Vue {
  @Prop(Object) readonly item: AnyEntity;
  @Prop(Array) readonly fields: BPCDisplayConfigField[];
  @Prop({ type: Array, default: () => [] }) readonly hiddenFields: string[];
  @Prop({ type: Array, default: () => [] }) readonly mainFields: string[];
  @Prop(Boolean) readonly loading: boolean;
  @Prop({ type: String, default: '' }) readonly prefixKey: string;

  // get fieldsToRender(): BPCDisplayConfigField[] {
  //   return this.fields.filter((field: BPCDisplayConfigField) => {
  //     return this.isFieldToRender(field);
  //   });
  // }

  // get orderedFieldsToRender(): BPCDisplayConfigField[] {
  //   return this.fieldsToRender.sort((a, b) => a.order - b.order);
  // }

  get itemFields(): string[] {
    return Object.keys(this.item).filter(fieldKey => {
      return this.isFieldToRender(fieldKey);
    });
  }

  hasFieldConfig(fieldKey: string): boolean {
    return !!this.getFieldConfig(fieldKey);
  }

  getFieldConfig(fieldKey: string): BPCDisplayConfigField {
    return this.fields.find((field: BPCDisplayConfigField) => {
      return field.key === fieldKey;
    });
  }

  isFieldToRender(fieldKey: string): boolean {
    return !this.hiddenFields.includes(`${this.prefixKey}${fieldKey}`);
  }

  isArray(fieldValue) {
    return isArray(fieldValue);
  }

  isObject(fieldValue) {
    return isObject(fieldValue);
  }

  getValue(fieldKey: string) {
    return get(this.item, fieldKey, '');
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
